<template>
  <div>
    <div v-if="error404">
      <page-not-found />
    </div>
    <div v-else class="cx-sec">
      <div class="cx-media--header" hidden>
        <div class="cx-media__img" style="background-image:url('/static/accessibility/cover-photo.jpg');background-position:bottom center;"></div>
      </div>
      <div class="cx-wrap--page">
        <h1 class="cx-t20 m-mapitem__title m-title cx-div">{{ $t('accessibility.barrierFreeTravelGuide') || 'accessibility.barrierFreeTravelGuide' }}</h1>
        <p v-if="settings.description" class="description -fade">{{ settings.description }}</p>
        <div class="cx-row">
          <div v-if="false" class="cx-col-md-3">
            <form class="filter-form">
              <h3 @click="showPop = true" class="cx-t01 -fade cx-div hide-mobile">{{ $t('accessibility.barrierFreeLevel') || 'accessibility.barrierFreeLevel' }}</h3>
              <button @click.prevent="showPop = true" class="cx-btn--full only-mobile">{{ $t('action.filter') || 'action.filter' }}</button>
              <div :class="{ '-active' : showPop === true }" id="popUpFilter" class="m-pop">
                <h3 class="cx-t01 -fade cx-div only-mobile">{{ $t('accessibility.barrierFreeLevel') || 'accessibility.barrierFreeLevel' }}</h3>
                <div v-if="loading" class="filter loading">
                  <div v-for="index in 4" :key="index">
                    <div class="block">
                      <div class="title placeholder" :style="`width: ${Math.ceil(Math.random()*20) + 30}%`"></div>
                      <div class="hr" />
                      <div class="option placeholder" :style="`width: ${Math.ceil(Math.random()*50) + 50}%`"></div>
                      <div class="option placeholder" :style="`width: ${Math.ceil(Math.random()*50) + 50}%`"></div>
                    </div>
                  </div>
                </div>
                <accessibility-filter-list v-else :options="filterOptions" :settings="settings" ref="filterList" @prefs-changed="prefsChanged" />

                <div class="filter-buttons">
                  <button v-if="!loading" @click.prevent="reset" class="cx-btn--sub btn-full-width">{{ $t('action.reset') || 'action.reset' }}</button>
                  <button @click="showPop = false" @click.prevent="updateActiveFilters" class="cx-btn--full only-mobile">{{ $t('action.confirm') || 'action.confirm' }}</button>
                </div>
              </div>

              <button v-if="showPop" @click.prevent="showPop = false"
                class="cx-modal__close cx-btn mobile-only" :aria-label="$t('action.close')"
              >
                <span class="cx-btn__icon">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </span>
              </button>
            </form>
          </div>

          <div class="cx-col-md-4">
            <div class="-border cx-div--outer m-tab-wrap">
              <button class="m-tab" 
                v-for="(tab, index) in tabs" :key="index" 
                :class="{ '-active': currentTabLabel === tab.id }"
                @click="currentTabLabel = tab.id">
                <span>{{$t(`accessibility.${tab.id}`) || `accessibility.${tab.id}`}}</span>
              </button>
            </div>
          </div>

          <div class="cx-col-md-8">
            <accessibility-search-form @update-search="updateSearch" :tab="currentTabLabel" :settings="settings" />

            <div v-if="loading" class="loading">
              <div class="row" v-for="(index) in 15" :key="index">
                <div class="placeholder" :style="`width: ${Math.ceil(Math.random()*50) + 50}%`"></div>
              </div>
            </div>

            <template v-else>
              <div v-if="filteredTabContents.length === 0" class="no-results-found">
                <p>{{ $t('common.noResultsFound') || 'common.noResultsFound' }}</p>
              </div>
              <accessibility-result v-else :results="filteredTabContents" @poiSelected="showPOI" @paging="scrollToTable" />
            </template>

            <accessibility-modal
              v-if="selectEntity != null"
              :detail="selectEntity" :settings="settings"
              @close="selectEntity = null"
            ></accessibility-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .description {
    margin-top: -1em;
    // margin-bottom: 2em;
  }

  .filter.loading {
    .block {
      margin-bottom: 1.5rem;
    }

    .title {
      height: 16.8px;
      width: 30%;
      margin: 3.1px 0;
    }

    .hr {
      width: 100%;
      border-top: 1px solid rgba(162, 162, 162, 0.2);
      margin: 0.5rem 0;
    }

    .option {
      height: 13px;
      margin: 0.3rem 0;
    }
  }

  .filter-form .cx-modal__close {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 99999;
  }

  .filter-buttons {
    button {
      margin-bottom: 16px;
    }
  }

  .no-results-found {
    text-align: center;
    padding-top: 2rem;
    position: sticky;
    top: 0;
  }

  .only-mobile {
    display: none;

    @media (max-width: $breakpoint-md) {
      display: block;
    }
  }

  .hide-mobile {
    @media (max-width: $breakpoint-md) {
      display: none;
    }
  }

  .btn-full-width {
    display: inline-block;
    width: 100%;
  }

  .loading {
    display: block;

    .row {
      padding: 0.5rem 32px;
      border-bottom: 1px solid rgba(162, 162, 162, 0.2);
    }

    .placeholder {
      content: '';
      background: #AAA;
      width: 100%;
      height: 27px;
      border-radius: 13px;
      animation: fading 1.5s infinite;
    }

    @keyframes fading {
      0% {
        opacity: .3;
      }
      
      50% {
        opacity: .5;
      }
      
      100% {
        opacity: .3;
      }
    }
  }
</style>

<style lang="scss">
  .m-pop{
    @media (max-width: $breakpoint-md){
      transition: all .3s ease-in-out;
      will-change: transform;
      position: fixed;
      bottom: 100%;
      left: 0;
      right: 0;
      z-index: 100;
      background: $color-white;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: auto;
      transform: translateY(0);
      &.-active{
        transform: translateY(100%);
        box-shadow: 0 0 30px 0 rgba($color-black, .5);
      }      
    }
    &__close{
      display: none;
      text-align: center;
      align-self: center;
      @media (max-width: $breakpoint-md){
        display: block;
      }
    }    
  }
  .m-tab-wrap{
    position: relative;
    overflow: hidden;
    border-radius: $br-base;
    overflow: auto;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    @media (min-width: $breakpoint-md) {
      white-space: normal;
      flex-wrap: wrap;
    }
  }
  .m-tab{
    @include bg-img;
    padding: 1rem;
    text-align: left;
    text-align: center;
    border: 0;
    background-image: url(/static/banner/sight.jpg);
    cursor: pointer;
    position: relative;
    color: $color-white;
    // box-shadow: 0 0 150px 15px $color-black inset;
    width: 45%;
    margin: 0 1px;
    overflow: hidden;  
    flex: 1 0 45%;
    align-self: stretch;
    box-shadow: inset 0 0 150px 15px rgba(61, 70, 73, .5);
    font-size: 1.2em;
    font-weight: bold;
    transition: box-shadow .1s ease-out;
    white-space: normal;
    &:first-child{
      margin-left: 0;
    }
    &:last-child{
      margin-right: 0;
    }
    &:not(.-active) {
      text-shadow: 0 0 7em black, 0 0 4em black, 0 0 3em black, 0 0 2em black, 0 0 1em black, 0 0 .5em black;
    }
    &:hover:not(.-active) {
      box-shadow: none;
    }
    i{
      font-size: 1.5em;
    }
    @media (min-width: $breakpoint-md) {
      margin: 0;
      padding: 2rem 1rem;
      width: 100%;
      flex: 0 1 100%;
    }
    & > span{
      display: block;
      margin-top: 13px;
      margin-bottom: 13px;
      position: relative;
      z-index: 2;
    }
    &.-active{
      box-shadow: 0 0 150px 0 rgba($color-yellow, 1) inset;
      color: $color-black;
      &:before{
        content: "";
        background-color: rgba($color-yellow, .8);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
      }       
    }
    &:focus{
      outline: 0;
    }
    &:nth-child(2) {
      background-image: url(https://content.macaotourism.gov.mo/uploads/mgto_planyourtrip/lrt1.jpg);
    }
    &:nth-child(3){
      background-image: url(/static/banner/border.jpg);
    }
    &:nth-child(4){
      background-image: url(/static/banner/expo.jpg);
    }
    &:nth-child(5){
      background-image: url(/static/banner/mall.jpg);
    }
    // &:nth-child(6){
    //   background-image: url(/static/banner/street.jpg);
    // }
    &:nth-child(6){
      background-image: url(/static/banner/hotel.jpg);
    }
    &:nth-child(7){
      background-image: url(/static/banner/restaurant.jpg);
    }                    
  }
</style>

<script>
import axios from 'axios';
import headerUpdater from '@/mixins/headerUpdater'
import AccessibilityModal from '@/components/AccessibilityModal';
import AccessibilityResult from '@/components/AccessibilityResult';
import AccessibilityFilterList from '@/components/AccessibilityFilterList';
import AccessibilitySearchForm from '@/components/AccessibilitySearchForm';
import RichSearchForm from '@/components/RichSearchForm';
import RichSearchSelect from '@/components/RichSearchSelect';
import RichSearchSimpleResultList from '@/components/RichSearchSimpleResultList';
import { POI_VIEW, TAB_VIEW } from '../constants/gtmce';

export default {
  name: 'accessibility-view',
  uit() {
    return [
      ['accessibility', [
        'sight', 'lrt', 'border', 'expo', 'mall', 'street', 'hotel', 'restaurant',
        'barrierFreeTravelGuide', 'barrierFreeLevel', 'wheelChairUser',
      ]],
      ['action', ['reset', 'filter', 'confirm', 'search', 'close']],
      ['common', [
        'previousPage', 'nextPage', 'noResultsFound', 'anyType', 'anyDistrict',
        'award', 'type', 'details',
      ]],
      ['dining', ['anyCuisine', 'anyCategory']],
      ['accommodation', ['anyStar']],
      ['media', ['aMap', 'googleMap']],
    ];
  },
  mixins: [headerUpdater({ firePageLoadedEvent: true })],
  header() {
    return {
      title: this.$t('accessibility.barrierFreeTravelGuide'),
    };
  },
  data() {
    return {
      loading: true,
      tabs: [
        { id: 'sight', icon: 'fas fa-archway' },
        { id: 'lrt', icon: 'fas fa-train' },
        { id: 'border', icon: 'fas fa-passport' },
        { id: 'expo', icon: 'fas fa-icons' },
        { id: 'mall', icon: 'fas fa-bags-shopping' },
        { id: 'hotel', icon: 'fas fa-hotel' },
        // { id: 'restaurant', icon: 'fas fa-utensils' },
      ],
      currentTabLabel: null,
      tabContents: [],
      filterOptions: [],
      filters: {},
      activeFilters: [],
      selectEntity: null,
      showPop: false,
      prefs: {},
      search: {
        keyword: '',
        sightCategory: '',
        restaurantCategory: '',
        star: '',
      },
      error404: false,
      determinedLanguageExistance: false,

      poi_view: POI_VIEW,
      tab_view: TAB_VIEW,
    };
  },
  components: {
    AccessibilityModal,
    AccessibilityResult,
    AccessibilityFilterList,
    AccessibilitySearchForm,
    RichSearchForm,
    RichSearchSelect,
    RichSearchSimpleResultList,
  },
  computed: {
    settings() {
      return this.$store.getters['accessibility/getSettings'];
    },
    filteredTabContents() {
      const keyword = this.search.keyword;
      const sight = this.search.sightCategory;
      const restaurant = this.search.restaurantCategory;
      const stars = this.search.star.split(',').filter(star => star !== '');
      return this.tabContents
        .filter(poi => poi.name.match(new RegExp(keyword, 'i')))
        .filter(poi => sight === '' || poi.category.includes(sight))
        .filter(poi => restaurant === '' || poi.category.includes(restaurant))
        .filter(poi => stars.length === 0 || stars.some(star => poi.category.includes(star)))
        ;
    },
    filterPossibilities() {
      return this.loading ? null : Array.from(
        this.tabContents.map(poi => poi.category)
          .filter(cat => cat !== undefined)
          .reduce((set, cat) => set.add(...cat), new Set())
      );
    },
  },
  methods: {
    updateSearch(search) {
      this.search = search;
    },
    showPOI(poi) {
      if (poi) {
        const params = {};
        params.element_name = poi.name;
        params.element_id = poi.id
        params.slug = poi.poiId || null; // some poi doesn't have link, such as 三盞燈
        params.parent_name = poi.category && poi.category[0] || null;
        params.value = 1;
        this.$gtmPush({
          ...this.poi_view,
          ...params,
        })
      }
      if (this.settings.tabs[0]) {
        const params = {};
        params.element_name = this.settings.tabs[0].name;
        params.element_id = 'tab-0';
        params.parent_name = poi.name;
        params.parent_id = poi.id;
        params.value = 1;
        this.$gtmPush({
          ...this.tab_view,
          ...params,
          a11yCat: poi.category,
          tab: 0
        })
      }
      this.selectEntity = poi;
    },
    updateOptions: function(key, val) {
      this.filters = {
        ...this.filters,
        [key]: val,
      }
    },
    updateActiveFilters: function() {
      this.$refs.filterList.report();
    },
    udpateFilterOptions() {
      const merge = (was, is) => {
        Object.keys(is).forEach((key) => {
          if (was[key]) {
            if (!was[key].includes(is[key])) {
              was[key].push(is[key]);
            }
          } else {
            was[key] = [is[key]];
          }
        });
        return was;
      };

      let filters = [];
      this.tabContents.forEach((tab) => {
        const branch = tab['infos'][this.settings.filter.section];
        if (!branch) {
          return;
        }

        Object.entries(branch).forEach((item) => {
          const name = item[0];
          const symbols = item[1][3];
          const index = filters.findIndex(filter => filter.name === name);
          if (index > -1) {
            filters[index].options = merge(filters[index].options, symbols);
          } else {
            filters.push({
              name,
              options: merge({}, symbols),
            });
          }
        });
      });
      this.filterOptions = filters;
    },
    scrollToTable() {
      var tableRectTop = document.querySelector(".m-mapitem__resultlist").getBoundingClientRect().top;
      if (tableRectTop < 0) {
        document.documentElement.scrollTop += tableRectTop;
      }
    },
    prefsChanged(prefs) {
      this.prefs = {};
      this.prefs = prefs;
    },
    reset() {
      this.$refs.filterList.clear();
      this.prefs = {};
      this.showPop = false;
    }
  },
  asyncData({ i18n, store }) {
    const { locale } = i18n;
    return Promise.all([
      store.dispatch('accessibility/FETCH_SETTINGS', { locale }),
    ]);
  },
  mounted() {
    this.currentTabLabel = 'sight';
    this.$gtmSet('vlang', this.$i18n.locale)
  },
  watch: {
    showPop(isShown) {
      if (isShown) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'auto';
      }
    },
    currentTabLabel: {
      immediate: false,
      handler() {
        this.loading = true;
        const link = `/api/accessibility/${this.$i18n.locale}/${this.currentTabLabel === 'lrt' ? this.currentTabLabel : this.currentTabLabel + 's'}.json`;
        const params = {
          lang: null,
          timestamp: new Date().getTime(),
        };
        this.search = {
          keyword: '',
          sightCategory: '',
          restaurantCategory: '',
          star: '',
        };
        axios(link, { params }).then((result) => {
          if (result.data) {
            this.tabContents = result.data;
            this.udpateFilterOptions();
            this.prefs = {};
            this.loading = false;
          }
        });
      },
    },
  },
};
</script>
